import { searchCommonConfig } from './common'

/**
 * Marinovel 品牌搜索页面配置
 */
export const searchConfig = {
  ...searchCommonConfig,
  colors: {
    inputBg: '#0000000A',
    startReadingBg: 'linear-gradient(135deg, #1660FB 0.03%, #4B9CFC 100%)',
  },
}
